import dayjs from "@lib/dayjs";
import {
  MeetingModeEnum,
  ReviewFormData,
} from "pages/CalendarsPage/SchedulingSection/form.types";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { isObjectEmpty } from "utils/helperFunction";

const ReviewMeetingPoll = ({
  formData,
  isMeetingInvite,
}: {
  formData: ReviewFormData;
  isMeetingInvite: boolean;
}) => {
  const userDetails = useSelector((state: RootState) => state.auth.user);

  console.log("userDetails", userDetails);
  console.log("formData", formData);

  if (isObjectEmpty(formData)) return;

  return (
    <div className="flex flex-col flex-1 overflow-y-auto no-scrollbar">
      {/* Meeting details */}
      <div className="flex flex-col gap-3.5 mt-9">
        <div className="flex items-center">
          <span className="text-xs font-semibold">Organizer :&nbsp;</span>
          <span className="text-xs font-medium text-light-black">
            {userDetails?.companyName}
          </span>
        </div>
        <div className="flex items-center">
          <span className="text-xs font-semibold">Meeting Title :&nbsp;</span>
          <span className="text-xs font-medium text-light-black">
            {formData?.meetingTitle}
          </span>
        </div>

        <div className="flex items-center">
          <span className="text-xs font-semibold">Meeting Type :&nbsp;</span>
          <span className="text-xs font-medium text-light-black">
            {MeetingModeEnum[formData?.meetingMode]}
          </span>
        </div>

        <div className="flex items-center">
          <span className="text-xs font-semibold">Meeting URL :&nbsp;</span>
          <span className="text-xs font-medium text-light-black">
            {formData?.url}
          </span>
        </div>

        <div className="flex flex-col gap-2">
          <span className="text-xs font-semibold">
            Meeting Description :&nbsp;
          </span>
          <span className="text-xs font-medium text-light-black">
            {formData?.meetingDescription}
          </span>
        </div>
      </div>

      {/* Recipient Details */}
      <div className="flex justify-between border-y border-dashed mt-8 py-4 gap-10">
        <div className="w-1/2">
          <span className="font-semibold text-sm">Recipient details :</span>
          <div className="flex items-center gap-4 mt-2.5">
            <div className="w-10 h-10 rounded-full bg-light-grey flex items-center justify-center flex-shrink-0">
              {formData?.candidateDetails?.profilePic ? (
                <img
                  src={formData?.candidateDetails?.profilePic}
                  className="w-9 h-9 rounded-full"
                />
              ) : (
                <span className="font-semibold text-sm text-white">
                  {formData?.candidateDetails?.fullName.charAt(0)}
                </span>
              )}
            </div>
            <div className="flex flex-col gap-1 w-full">
              <div className="flex items-center justify-between">
                <span className="font-medium text-xs">
                  {formData?.candidateDetails?.fullName}
                </span>
                <span className="font-medium text-light-black text-xs">
                  RB-5600MN
                </span>
              </div>
              <span className="text-xs text-light-black">
                {formData?.candidateDetails?.email}
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col w-1/2 gap-2">
          <span className="font-semibold text-sm">Job details :</span>
          <div className="flex flex-col gap-1">
            <span className="font-medium text-xs">
              {formData?.jobDetails?.title}
            </span>
            {/* <span className="text-xs text-light-black">Cybodin Solution</span> */}
          </div>
        </div>
      </div>

      {/* Recruiter Agent Details */}
      {/* <div className="flex justify-between border-y border-dashed mt-8 py-4">
      <div className="w-1/2">
        <span className="font-semibold text-sm">
          Recruiter agent details :
        </span>
        <div className="flex items-center gap-4 mt-2.5">
          {userDetails?.profilePic ? (
            <img
              src={userDetails?.candidateProfilePic}
              className="w-9 h-9 rounded-full"
            />
          ) : (
            <div className="w-10 h-10 rounded-full bg-light-grey">
              <span>
                {userDetails.firstName?.charAt(0)}
                {userDetails?.lastName?.charAt(0)}
              </span>
            </div>
          )}
          <div className="flex flex-col gap-1">
            <span className="font-medium text-xs">Candidate Name</span>
            <span className="text-xs text-light-black">Candidate Email</span>
          </div>
        </div>
      </div>
    </div> */}

      {isMeetingInvite ? (
        <div className="flex flex-col mt-4 gap-3">
          <div className="flex items-center">
            <span className="text-xs font-semibold">
              Meeting Duration :&nbsp;
            </span>
            <span className="text-xs font-medium text-light-black">
              {formData?.meetingDuration?.label}
            </span>
          </div>
          <div className="flex">
            <span className="text-xs font-semibold">
              Meeting Timing :&nbsp;
            </span>
            <div className="">
              {Object.entries(formData?.availabilitySlots).map(
                ([date, slots]) => (
                  <div key={date} className="flex flex-col pl-3 gap-1">
                    {slots.map((slot, idx) => (
                      <span
                        key={idx}
                        className="font-medium text-xs text-light-black"
                      >
                        {dayjs(slot?.startTime).format("dddd MMM Do")},{" "}
                        {dayjs(slot?.startTime).format("h:mm A")} -{" "}
                        {dayjs(slot?.endTime).format("h:mm A")}
                      </span>
                    ))}
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      ) : (
        // Meeting availability slots
        <div className="flex flex-col mt-4 gap-3">
          <div className="flex items-center">
            <span className="text-xs font-semibold">
              Meeting Duration :&nbsp;
            </span>
            <span className="text-xs font-medium text-light-black">
              {formData?.meetingDuration?.label}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-xs font-semibold">
              Meeting Timings :&nbsp;
            </span>
            <div className="space-y-2 mt-0.5">
              {Object.entries(formData?.availabilitySlots)
                .sort(
                  ([dateA], [dateB]) =>
                    new Date(dateA).getTime() - new Date(dateB).getTime()
                )
                .map(([date, slots]) => (
                  <div key={date} className="rounded-md px-2">
                    <span className="font-semibold text-xs text-light-black">
                      {new Date(date).toDateString()}
                    </span>
                    <div className="flex flex-col pl-3 gap-1">
                      {slots.map((slot, idx) => (
                        <span
                          key={idx}
                          className="font-medium text-xs text-light-black"
                        >
                          - {dayjs(slot?.startTime).format("h:mm a")} -{" "}
                          {dayjs(slot?.endTime).format("h:mm a")}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ReviewMeetingPoll;
